// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"bd639bc5","703":"ffbd37a6","787":"a871138b"}[chunkId] + ".chunk.js";
};